import React from 'react';
import AnimatedText from 'react-animated-text-content';
import { Col, Container, Row } from 'react-bootstrap';

import './team.css';

const Staking = () => {
  const stakingContent = (
    <>
      <Container fluid className='np nm team__main__container'>
        <Container className='team__container'>
          <Row>
            <Col>
              <h1 className='team__h1 animate__animated animate__bounce animate__faster'>
                <AnimatedText
                  type='chars' // animate words or chars
                  animation={{
                    x: '200px',
                    y: '-30px',
                    scale: 1.1,
                    ease: 'ease-in-out',
                  }}
                  animationType='throw'
                  interval={0.06}
                  duration={1}
                  tag='p'
                  className='animated-paragraph'
                  includeWhiteSpaces
                  threshold={0.1}
                  rootMargin='20%'
                >
                  STAKING
                </AnimatedText>
              </h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className='contest__p__box'>
                All the rewards derived from the utilities will be given to
                whoever puts an NFT in staking on our staking page, all the
                prizes will be given in our cryptocurrency. Owning our
                cryptocurrency offers many new utilities which we will announce
                soon!
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );

  return <div>{stakingContent}</div>;
};

export default Staking;
